import { stringify } from 'querystring';

export interface CustomerData {
    customerId?: string;
    mobileNo: string;
    dateOfBirth?: string;
    firstName: string;
    lastName: string;
    emailId?: string;
    description?: string;
    color?: string;
    model?: string;
    variant?: string;
}

export interface VinEngineData {
    vinNumber: string;
    engineNumber: string;
}

export interface CustomerDetailsData {
    vehRegNumber: string;
    vinNumber: string;
    mcall: boolean;
}

export interface SVTDetailsData {
    dateOfBirth;
    primaryMobileNo;
    vehRegNumber?: string;
    vinNumber?: string;
}

export interface StartStopSVT {
    vinNumber: string;
    command: string;
    productOwnId: string;
    customerId: string;
}
export interface CheckSVTStatus {
    vinNumber: string;
    requestId: string;
    productOwnId: string;
    emailId: string;
}

export interface LoginData {
    userName: string;
    password: string;
}

export interface HistoryEventType {
    eventType: string;
    fromDate: string;
    toDate: string;
}

export interface EventTypeCount {
    eventType: string;
    fromDate: '';
    toDate: '';
}

export interface Deserializable {
    deserialize(input: any): this;
}

// export interface PreferenceDataInterface {
//     preferredMethod: string;
//     preferredContactStartTime: string;
//     preferredContactEndTime: string;
//     preferredContactDay: string;
// }

export interface VehicleDashboardInterface {
    vinNumber: string;
    productOwnId: string;
}

export interface TripDetailInterface {
    vinNumber: string;
}

export interface ServiceHistoryDetailInterface {
    vinNumber: string;
}
export interface RsaInterface {
    vinNumber: string;
}

export interface TransactionInterface {
    vinNumber: string;
}

export interface DongleInfoInterface {
    deviceId: string;
    vinNumber: string;
    addedBy : string;
}

export interface DongleDeviceInterface {
    emailId: string;
    vinNumber: string;
    dongleSrNumber: string;
    deviceId: string;
    productOwnId: string;
    dongleName: string;
    dongleValidity: string;
    addedBy:string;
}